import React, {ReactElement} from "react";

import DownloadButton, {DownloadButtonProps} from "@components/DownloadButton";

import {GridWrapperProps} from '@/theme/lib';
import {StyledDownloadButtons} from '@components/DownloadButtons/DownloadButtons.styles';

export interface DownloadButtonsProps extends GridWrapperProps {
  downloads: DownloadButtonProps[];
};

export default function DownloadButtons(data: DownloadButtonsProps): ReactElement {
  return (
    <StyledDownloadButtons {...data}>
      <ul className="download-buttons__list">
        {data.downloads.map((button, key) => {
          return <li key={`download-button-${key}`} className="download-buttons__list-item">
            <DownloadButton {...button}></DownloadButton>
          </li>
          })
        }
      </ul>
    </StyledDownloadButtons>
  );
}
